import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import $ from 'jquery';
import * as CorgeeHelper from '@lib/corgeeHelper';
import { buildChatWindowUrl, getChatBaseUrl } from '@lib/chatUrl';
import ConversationApi from './api/ConversationApi';
import {
  getSelectedConversationIds,
  getSelectedConversationTitles,
} from './selectionUtils';
import ActionMenuConversation from './ActionMenuConversation';
import ProfilePictureModal from './ProfilePictureModal';
import CorgeeStorageHelper from '@components/Globals/CorgeeStorageHelper';
import type { ConversationItemProps } from './types';
import type { ConversationDetail, ConversationLayer } from '../../types/conversation';
import './ConversationViewTitle.css';
import type { ConversionResult } from './modals/ConvertToModal';
// import conversationApi from '@/services/conversationApi';
import CustomFields from '@components/CustomFields/CustomFields';
import EditDetailHistory from './EditHistory/EditDetailHistory';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { conversationBus } from '@/lib/conversationBus';
import EditMultipleCards from './modals/EditMultipleCards/EditMultipleCardsModal';
import { authStorage } from '@/lib';
import { useNavigate } from 'react-router-dom';

interface ConversationViewTitleState {
  finished: boolean;
  title: string;
  titleOriginal: string;
  updatedBy: string;
  updatedAt: string;
  isRedFlag: boolean;
  isFavorite: boolean;
  icon: string;
  isImportant: boolean;
  enableEditTitle: boolean;
  firstLayerColor: string;
  conversationLayers: ConversationLayer[];
  openProfilePictureDialog: boolean;
  positionProfilePictureX: number;
  positionProfilePictureY: number;
  canOpenChat: boolean;
  reqNewChat: {
    Participant1: number;
    Participant2: number;
    ChatID: number;
  };
  isGroupDefault: boolean | null;
  showDetails: boolean;
  modalEditMultipleCard: { open: boolean; config: any };
  tabIndex: number;
  edithistory: {
    open: boolean;
    title: string;
    customField: any;
    onSaveModal: any;
  };
}

declare global {
  interface Window {
    chatWebReact: Window | null;
  }
}

let windowReferenceSafari: Window | null = null;

class ConversationViewTitle extends Component<ConversationItemProps, ConversationViewTitleState>
{
  private spanTitle: HTMLSpanElement | null = null;
  private inputTitle: HTMLInputElement | null = null;
  private _titleClickHandler: EventListener | null = null;
  private _unsubRedflag: (() => void) | null = null;
  // private titleElement: HTMLDivElement | null = null;
  private profilePictureItem: any = null;

  static getDerivedStateFromProps(
    props: ConversationItemProps,
    state: ConversationViewTitleState,
  ): Partial<ConversationViewTitleState> | null
  {
    // Keep state.icon in sync with props when it changes (e.g. background cache refresh or Convert-To)
    if (props.conversation.Icon !== undefined && props.conversation.Icon !== state.icon)
    {
      return { icon: props.conversation.Icon };
    }
    return null;
  }

  constructor(props: ConversationItemProps)
  {
    super(props);

    const layers =
      props.conversation.ConversationLayers && props.conversation.ConversationLayers.length > 0
        ? props.conversation.ConversationLayers.filter(x => x.LayerId !== 0)
          .sort((a, b) => (a.PriorityInConfigValue || 0) - (b.PriorityInConfigValue || 0))
        : [];

    this.state = {
      finished: props.conversation.Finished || false,
      title: props.conversation.Title || '',
      titleOriginal: props.conversation.Title || '',
      updatedBy: props.conversation.UpdatedBy || '',
      updatedAt: props.conversation.UpdatedAt || '',
      isRedFlag: props.conversation.IsRedFlag || false,
      isFavorite: props.conversation.IsFavorite || false,
      icon: props.conversation.Icon || '',
      isImportant: props.conversation.IsImportant || false,
      enableEditTitle: false,
      firstLayerColor:
        layers && layers.length > 0
          ? (layers[0] as any).LayerColor
            ? (layers[0] as any).LayerColor
            : (layers[0] as any).Color
          : '',
      conversationLayers: layers,
      openProfilePictureDialog: false,
      positionProfilePictureX: 0,
      positionProfilePictureY: 0,
      canOpenChat: false,
      isGroupDefault: null,
      reqNewChat: {
        Participant1: 0,
        Participant2: 0,
        ChatID: 0,
      },
      showDetails: props.initialShowDetails ?? (props.forceShowDetails === true),
      modalEditMultipleCard: { open: false, config: null },
      tabIndex: props.initialTabIndex ?? 0,
      edithistory: { open: false, title: '', customField: null, onSaveModal: null },
    };

    this.enableInputClickEvent = this.enableInputClickEvent.bind(this);
    this.getClickHandler = this.getClickHandler.bind(this);

    this.onSaveTitle = this.onSaveTitle.bind(this);
    this.onEditTitle = this.onEditTitle.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);

    this.onChangeFinished = this.onChangeFinished.bind(this);

    this.onGoToProjectView = this.onGoToProjectView.bind(this);
    this.onMarkAsRedFlag = this.onMarkAsRedFlag.bind(this);
    this.onMarkAsImportant = this.onMarkAsImportant.bind(this);
    this.onSendToBookmarks = this.onSendToBookmarks.bind(this);
    this.onConverToProccess = this.onConverToProccess.bind(this);
    this.onOpenInfoWindow = this.onOpenInfoWindow.bind(this);
    this.onChangedLayersLocal = this.onChangedLayersLocal.bind(this);
    this.onOpenEditHistory = this.onOpenEditHistory.bind(this);
    this.onCloseEditHistory = this.onCloseEditHistory.bind(this);

    this.onHoverProfilePicture = this.onHoverProfilePicture.bind(this);
    this.closeProfilePictureModal = this.closeProfilePictureModal.bind(this);
    this.onLeaveMiniaturePicture = this.onLeaveMiniaturePicture.bind(this);
    this.openChat = this.openChat.bind(this);
  }

  onGoToProjectView(e: React.MouseEvent)
  {
    e.preventDefault();
    const { conversation } = this.props;

    if (conversation.ProjectIsEnable === false) return;

    const path = `/ProjectDetails/${conversation.ProjectId}`;
    if (e.shiftKey || e.ctrlKey || e.metaKey)
    {
      window.open(window.location.origin + path, '_blank');
    }
    else
    {
      this.props.navigate?.(path);
      // Lets hosts like the Top Search popover close themselves
      this.props.corgeeFunctions?.onNavigateToProject?.(conversation.ProjectId ?? null);
    }
  }

  onOpenInfoWindow(e: React.MouseEvent)
  {
    if (e)
    {
      e.preventDefault();
      e.stopPropagation();
    }

    if (this.props.isMultiple)
    {
      const selectedIds = getSelectedConversationIds(
        this.props.getSelectedConversations,
        this.props.conversation.ConversationId,
      );

      if (selectedIds.length === 0) return;

      const config = {
        api: {
          url: this.props.api.url,
          token: this.props.api.token,
          TenancyName: authStorage.getTenantData(),
          PersonId: authStorage.getPersonId(),
          SocketServer: (this.props.SocketConnectionId || '') + '/usersNotificationManager',
        },
        ConversationIds: selectedIds,
        SelectedConversations: getSelectedConversationTitles(
          this.props.getSelectedConversations,
          this.props.conversation,
        ),
        conversation: this.props.conversation,
        DashboardId: String(this.props.conversation.DashboardId ?? ''),
        openmodal: true,
        hasmaxheight: true,
        isdraggable: true,
        closeonescape: true,
        allowMinimize: false,
        allowMaximize: false,
        title: 'Edit multiple cards details',
        disableAutoSave: true,
        canEdit: true,
        functions: {
          getSocketConnectionId: () => this.props.SocketConnectionId ?? '',
          reloadConversations: (_data: any, updatedConv: any) =>
          {
            selectedIds.forEach((id: string) =>
            {
              const convId = Number(id);
              if (this.props.onUpdateConversation)
              {
                const updatePayload: Record<string, any> = {};
                if (updatedConv?.ConversationLayers !== undefined)
                  updatePayload.ConversationLayers = updatedConv.ConversationLayers;
                if (updatedConv?.OwnedBy != null && updatedConv.OwnedBy !== '')
                {
                  updatePayload.OwnedBy = updatedConv.OwnedBy;
                  updatePayload.OwnedById = updatedConv.OwnedById;
                }
                if (Object.keys(updatePayload).length > 0)
                  this.props.onUpdateConversation(convId, updatePayload as any, false);
              }
              conversationBus.emit('layer-updated', {
                conversationId: convId,
                layerId: 0,
                layerData: updatedConv?.ConversationLayers ?? {},
                sourceId: 'multi-edit',
              });
            });
          },
        },
      };

      this.setState({ modalEditMultipleCard: { open: true, config } });
      return;
    }

    const nextShow = !this.state.showDetails;
    this.setState({ showDetails: nextShow, tabIndex: 0 });
    this.props.onShowDetailsChange?.(nextShow);
    this.props.onTabChange?.(0);
  }

  onMarkAsRedFlag(e: React.MouseEvent)
  {
    e.preventDefault();
    const { conversation } = this.props;
    const newRedFlag = !this.state.isRedFlag;

    this.setState({ isRedFlag: newRedFlag }, () =>
    {
      conversationBus.emit('redflag-updated', {
        conversationId: conversation.ConversationId,
        isRedFlag: newRedFlag,
      });

      setTimeout(() =>
      {
        if (this.props.onUpdateConversation)
        {
          this.props.onUpdateConversation(
            this.props.conversation.ConversationId,
            { IsRedFlag: newRedFlag } as Partial<ConversationDetail>,
            true,
            'header',
          );
        }
      }, 0);

      const requestParams = {
        conversations: [
          {
            ConfigValueId: conversation.ConfigValueId,
            ConversationId: conversation.ConversationId,
            CoreTaskId: conversation.CoreTaskId,
            CreatedByID: conversation.CreatedByID,
            Finished: this.state.finished,
            Icon: conversation.Icon,
            IsRedFlag: !newRedFlag,
            ProjectId: conversation.ProjectId,
            SideMenuText: conversation.SideMenuText,
            Title: this.state.title,
            UpdatedAt: this.state.updatedAt,
            callService: true,
          },
        ],
      };

      if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarStart)
      {
        this.props.corgeeFunctions.loadingBarStart();
      }

      ConversationApi.updateRedFlags(this.props.api, requestParams)
        .then(_response =>
        {
          if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarComplete)
          {
            this.props.corgeeFunctions.loadingBarComplete();
          }

          const conversationsIds = requestParams.conversations
            .map(obj => obj.ConversationId)
            .join(',');
          ConversationApi.SetConversationsAsViewed(this.props.api, {
            ConversationIds: conversationsIds,
          }).then(_r2 => {});
        })
        .catch(error =>
        {
          console.error(error);
        });
    });
  }

  onMarkAsImportant(e: React.MouseEvent)
  {
    e.preventDefault();
    const { conversation } = this.props;
    const newImportant = !this.state.isImportant;
    this.setState({ isImportant: newImportant }, () =>
    {
      setTimeout(() =>
      {
        if (this.props.onUpdateConversation)
        {
          this.props.onUpdateConversation(
            this.props.conversation.ConversationId,
            { IsImportant: newImportant } as Partial<ConversationDetail>,
            true,
            'header',
          );
        }
      }, 0);

      const requestParams = {
        conversations: [
          {
            ConfigValueId: conversation.ConfigValueId,
            ConversationId: conversation.ConversationId,
            CoreTaskId: conversation.CoreTaskId,
            CreatedByID: conversation.CreatedByID,
            Finished: this.state.finished,
            Icon: conversation.Icon,
            IsImportant: !this.state.isImportant,
            ProjectId: conversation.ProjectId,
            SideMenuText: conversation.SideMenuText,
            Title: this.state.title,
            UpdatedAt: this.state.updatedAt,
            callService: true,
          },
        ],
      };

      if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarStart)
      {
        this.props.corgeeFunctions.loadingBarStart();
      }

      ConversationApi.updateImportant(this.props.api, requestParams)
        .then(_response =>
        {
          if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarComplete)
          {
            this.props.corgeeFunctions.loadingBarComplete();
          }

          const conversationsIds = requestParams.conversations
            .map(obj => obj.ConversationId)
            .join(',');
          ConversationApi.SetConversationsAsViewed(this.props.api, {
            ConversationIds: conversationsIds,
          }).then(_r2 => {});
        })
        .catch(error =>
        {
          console.error(error);
        });
    });
  }

  onSendToBookmarks(e: React.MouseEvent)
  {
    e.preventDefault();
    e.stopPropagation();

    const { conversation, api, SocketConnectionId } = this.props;
    const newIsFavorite = !this.state.isFavorite;

    this.setState({ isFavorite: newIsFavorite }, () =>
    {
      if (this.props.onUpdateConversation)
      {
        this.props.onUpdateConversation(
          conversation.ConversationId,
          { IsFavorite: newIsFavorite },
          true,
          'header',
        );
      }
    });

    const configValueId = CorgeeHelper.getBookmarksConfigValueId();
    ConversationApi.getDashboardsByConfigValueId(api, configValueId)
      .then((response: any) =>
      {
        const dashboards = response;
        if (dashboards && dashboards.length > 0)
        {
          const dashboardId = dashboards[0].DashboardId;
          const dashboardGroups = dashboards[0].DashboardGroups || [];
          const dashboardGroupIdSend =
            dashboardGroups.length > 0 ? dashboardGroups[0].DashboardGroupId : 0;

          if (newIsFavorite)
          {
            const params = {
              dashboardId,
              conversationId: conversation.ConversationId,
              dashboardGroupIdSend,
              includeAllConversations: true,
              socketid: SocketConnectionId || '',
              isBookmark: newIsFavorite,
            };

            ConversationApi.addDashboardGroupByParameters(api, params);
          }
          else
          {
            const params = {
              dashboardId,
              conversationId: conversation.ConversationId,
              dashboardGroupIdSend,
              DashboardGroupIdDefault: 0,
              pParentId: conversation.ParentConversationId
                ? conversation.ParentConversationId
                : conversation.ConversationId,
              pDashboardGroupId: dashboardGroupIdSend,
              IsFromBookmark: true,
              layersToHide: CorgeeStorageHelper.getLayersToHide()?.join(',') || '0',
              socketid: SocketConnectionId ? SocketConnectionId : '',
            };

            ConversationApi.DeleteDashboardGroupConversation(api, params);
          }
        }
        return Promise.resolve();
      })
      .then(() =>
      {
        const params = {
          conversationId: conversation.ConversationId,
          socketid: SocketConnectionId || '',
        };
        return ConversationApi.notifIsFavoriteExternal(api, params);
      })
      .then(() =>
      {
        return ConversationApi.SetConversationsAsViewed(api, {
          ConversationIds: conversation.ConversationId.toString(),
        });
      })
      .catch(error => console.error('Error updating bookmark:', error));
  }

  onChangeFinished(e: React.ChangeEvent<HTMLInputElement>)
  {
    this.setState({ finished: e.target.checked });
    let dashboardgroupid = this.props.conversation.DashboardGroupId;

    if (
      this.props.conversation.RelatedConversationId &&
      this.props.conversation.RelatedConversationId > 0
    )
    {
      const relatedElement = $(
        ".liConversationTitle.liConversationItem[data-conversationid='" +
          this.props.conversation.RelatedConversationId +
          "']",
      );
      dashboardgroupid = relatedElement.data('groupid');
    }

    dashboardgroupid =
      dashboardgroupid == null ? this.props.conversation.DashboardGroupId : dashboardgroupid;

    const requestParams = {
      DashboardGroupId: dashboardgroupid,
      ConversationId: this.props.conversation.ConversationId,
      Finished: e.target.checked,
      SocketConnectionId:
        this.props.SocketConnectionId != undefined && this.props.SocketConnectionId != null
          ? this.props.SocketConnectionId
          : '',
    };

    if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarStart)
    {
      this.props.corgeeFunctions.loadingBarStart();
    }

    ConversationApi.updateComplete(this.props.api, requestParams).then(response =>
    {
      if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarComplete)
      {
        this.props.corgeeFunctions.loadingBarComplete();
      }

      if (response !== false)
      {
        if (this.props.corgeeFunctions && this.props.corgeeFunctions.callBackUpdateComplete)
        {
          this.props.corgeeFunctions.callBackUpdateComplete(response);
        }
      }

      ConversationApi.SetConversationsAsViewed(this.props.api, {
        ConversationIds: requestParams.ConversationId.toString(),
      }).then(() => {});
    });

    if (this.props.onUpdateConversation)
    {
      this.props.onUpdateConversation(
        this.props.conversation.ConversationId,
        {
          Finished: e.target.checked,
          Body: this.props.conversation.Body,
        } as Partial<ConversationDetail>,
        true,
        'header',
      );
    }
  }

  onChangeTitle(e: React.ChangeEvent<HTMLInputElement>)
  {
    e.preventDefault();
    this.setState({ title: e.target.value });
  }

  onSaveTitle(e: React.MouseEvent)
  {
    e.preventDefault();

    if (!this.inputTitle) return;

    let newTitle = this.inputTitle.value;
    newTitle = '<p>' + newTitle + '</p>';
    newTitle = $('<div>').html(newTitle).text();

    const regexEmptyValue = /\S/;
    if (!regexEmptyValue.test(newTitle) || newTitle == null)
    {
      return;
    }

    this.setState(
      {
        title: newTitle,
        enableEditTitle: false,
        titleOriginal: newTitle,
      },
      () =>
      {
        this.enableInputClickEvent();
      },
    );

    const requestParams = {
      ConversationId: this.props.conversation.ConversationId,
      Title: newTitle,
    };

    if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarStart)
    {
      this.props.corgeeFunctions.loadingBarStart();
    }

    ConversationApi.updateTitle(this.props.api, requestParams)
      .then((response: any) =>
      {
        this.setState({
          updatedBy: response.UpdatedBy,
          updatedAt: response.UpdatedAt,
        });

        conversationBus.emit('title-updated', {
          conversationId: this.props.conversation.ConversationId,
          title: newTitle,
        });

        if (this.props.onUpdateConversation)
        {
          const newAttrs = {
            Title: newTitle,
            UpdatedBy: response.UpdatedBy,
            UpdatedAt: response.UpdatedAt,
          } as Partial<ConversationDetail>;
          this.props.onUpdateConversation(
            this.props.conversation.ConversationId,
            newAttrs,
            true,
            'header',
          );
        }
        if (this.props.corgeeFunctions && this.props.corgeeFunctions.loadingBarComplete)
        {
          this.props.corgeeFunctions.loadingBarComplete();
        }

        ConversationApi.SetConversationsAsViewed(this.props.api, {
          ConversationIds: this.props.conversation.ConversationId.toString(),
        }).then(() => {});
      })
      .catch(error =>
      {
        console.error(error);
      });
  }

  onEditTitle(e: React.KeyboardEvent)
  {
    e.preventDefault();
    if (e.keyCode)
    {
      if (e.keyCode === 27)
      {
        this.setState(
          {
            enableEditTitle: false,
            title: this.state.titleOriginal,
          },
          () =>
          {
            this.enableInputClickEvent();
          },
        );
        return;
      }
      else if (e.keyCode !== 13)
      {
        return;
      }
    }

    this.onSaveTitle(e as any);
  }

  getClickHandler(onClick: (e: any) => void, onDblClick: (e: any) => void, delay: number = 250)
  {
    let timeoutID: ReturnType<typeof setTimeout> | null = null;
    return (event: any) =>
    {
      if (!timeoutID)
      {
        timeoutID = setTimeout(() =>
        {
          onClick(event);
          timeoutID = null;
        }, delay);
      }
      else
      {
        clearTimeout(timeoutID);
        timeoutID = null;
        onDblClick(event);
      }
    };
  }

  enableInputClickEvent()
  {
    if (!this.spanTitle) return;

    if (this._titleClickHandler)
    {
      this.spanTitle.removeEventListener('click', this._titleClickHandler);
      this._titleClickHandler = null;
    }

    this._titleClickHandler = this.getClickHandler(
      e =>
      {
        e.preventDefault();
        if (this.props.corgeeFunctions && (this.props.corgeeFunctions as any).openInfoWindow)
        {
          (this.props.corgeeFunctions as any).openInfoWindow(this.props.conversation);
        }
      },
      e =>
      {
        e.preventDefault();
        if (CorgeeHelper.convHasTitleEditPermissions(this.props.conversation))
        {
          this.setState({ enableEditTitle: true });
        }
      },
      400,
    ) as EventListener;

    this.spanTitle.addEventListener('click', this._titleClickHandler);
  }

  openChat(personId: number)
  {
    if (this.props.corgeeFunctions && (this.props.corgeeFunctions as any).openChat)
    {
      (this.props.corgeeFunctions as any).openChat(personId);
    }
    else
    {
      const { canOpenChat, reqNewChat } = this.state;
      if (canOpenChat === true)
      {
        // const _projectIdVal = this.props.conversation.ProjectId;
        // const _UpdateAtVal = this.props.conversation.UpdatedAt;
        // const _ProjectNameVal = this.props.conversation.ProjectName ? this.props.conversation.ProjectName : this.state.title;
        const urlChat = getChatBaseUrl();

        try
        {
          if (window.chatWebReact !== null && window.chatWebReact !== undefined)
          {
            if (
              window.chatWebReact.location !== null &&
              window.chatWebReact.location !== undefined &&
              window.chatWebReact.location.origin + window.chatWebReact.location.pathname ===
                urlChat &&
              window.chatWebReact.closed === false
            )
            {
              window.chatWebReact.focus();
            }
          }
        }
        catch (e) {}

        const isSafari = CorgeeHelper.isSafari();

        if (isSafari)
        {
          windowReferenceSafari = window.open();
        }

        ConversationApi.createNewPrivateChat(this.props.api, reqNewChat).then(
          (chatResponse: any) =>
          {
            const ChatId = chatResponse.ChatID != undefined ? chatResponse.ChatID : 0;

            if (isSafari && windowReferenceSafari)
            {
              windowReferenceSafari.location.href = buildChatWindowUrl(ChatId);
              return;
            }

            try
            {
              if (window.chatWebReact !== null && window.chatWebReact !== undefined)
              {
                if (
                  window.chatWebReact.location !== null &&
                  window.chatWebReact.location !== undefined &&
                  window.chatWebReact.location.origin + window.chatWebReact.location.pathname ===
                    urlChat &&
                  window.chatWebReact.closed === false
                )
                {
                  window.chatWebReact = window.open(
                    buildChatWindowUrl(ChatId),
                    'chatWebReact',
                  );
                  setTimeout(() =>
                  {
                    window.chatWebReact?.location.reload();
                  }, 200);
                }
                else
                {
                  window.chatWebReact = window.open(
                    buildChatWindowUrl(ChatId),
                    'chatWebReact',
                  );
                }
              }
              else
              {
                window.chatWebReact = window.open(
                  buildChatWindowUrl(ChatId),
                  'chatWebReact',
                );
                window.chatWebReact?.focus();
              }
            }
            catch (e)
            {
              window.chatWebReact = null;

              const isFirefox = CorgeeHelper.isFirefox();
              if (isFirefox)
              {
                setTimeout(() =>
                {
                  window.chatWebReact = window.open(
                    buildChatWindowUrl(ChatId),
                    'chatWebReact',
                  );
                  window.chatWebReact?.focus();
                }, 1000);
              }
              else
              {
                window.chatWebReact = window.open(
                  buildChatWindowUrl(ChatId),
                  'chatWebReact',
                );
              }
            }
          },
        );
      }
    }
  }

  closeProfilePictureModal(e?: React.MouseEvent)
  {
    if (e)
    {
      e.preventDefault();
    }
    this.setState({ openProfilePictureDialog: false });
  }

  onLeaveMiniaturePicture()
  {
    if (this.props.corgeeFunctions?.onLeaveProfilePicture)
    {
      this.props.corgeeFunctions.onLeaveProfilePicture();
      return;
    }

    if (this.profilePictureItem && this.profilePictureItem.closeFromOutSide)
    {
      this.profilePictureItem.closeFromOutSide();
    }
  }

  onHoverProfilePicture(e: React.MouseEvent)
  {
    const dm = false; //CorgeeStorageHelper.isDarkMode();
    e.preventDefault();

    // If a host app (e.g. Chat) provides its own profile hover, delegate to it
    // instead of opening the web ProfilePictureModal.
    if (this.props.corgeeFunctions?.onHoverProfilePicture)
    {
      const personId = this.props.conversation?.PersonId;
      if (personId)
      {
        this.props.corgeeFunctions.onHoverProfilePicture(e, personId);
      }
      return;
    }

    const _div = document.getElementsByClassName('corgee_com_profile-picture-modal-outside')[0];
    if (!_div)
    {
      if (!dm)
      {
        $('.see-all-replies').blur();
        $('.corgee_com_card-hide-details-btn').blur();
        $('.corgee_com_card-see-more-btn').blur();
      }
      let positionY = (e.target as HTMLElement).getBoundingClientRect().y;
      let positionX = (e.target as HTMLElement).getBoundingClientRect().x;

      if (window.innerHeight - positionY < 145)
      {
        positionY = positionY - 165;
      }
      if (window.innerWidth - positionX < 450)
      {
        positionX = positionX - 470;
      }
      this.setState({
        openProfilePictureDialog: true,
        positionProfilePictureY: positionY,
        positionProfilePictureX: positionX,
      });
    }
  }

  onConverToProccess(response: ConversionResult[])
  {
    const strConversationsIds = response.map(c => c.ConversationId).join(',');
    const DashboardId = this.props.conversation.DashboardGroupId;
    const LayersToHide = CorgeeStorageHelper.getLayersToHide()?.join(',') || '0';
    ConversationApi.GetConversationsByIdsMultiedition({
      strConversationsIds,
      DashboardId,
      LayersToHide,
    }).then((response2: any) =>
    {
      for (let i = 0; i < response.length; i++)
      {
        for (let j = 0; j < response2.length; j++)
        {
          if (response[i]?.ConversationId === response2[j]?.ConversationId)
          {
            const updated = response2[j];
            const newIcon = updated?.Icon || '';
            const updates: Partial<ConversationDetail> = {
              Icon: newIcon,
              ConfigValueId: updated?.ConfigValueId,
              SideMenuText: updated?.SideMenuText,
              _convertedAt: Date.now(),
            };
            // Only update local state for this component's own conversation
            if (updated?.ConversationId === this.props.conversation.ConversationId)
            {
              this.setState({ icon: newIcon });
            }
            if (this.props.onUpdateConversation)
            {
              this.props.onUpdateConversation(
                response[i]?.ConversationId || 0,
                updates,
                true,
                'header',
              );
            }

            // onUpdateConversation only reaches this component's own host.
            conversationBus.emit('conversation-updated', {
              conversationId: response[i]?.ConversationId || 0,
              updates: { ...updates, refreshCustomFields: true },
            });
          }
        }
      }
    });
  }

  componentDidMount()
  {
    this.enableInputClickEvent();

    this._unsubRedflag = conversationBus.on('redflag-updated', ({ conversationId, isRedFlag }) =>
    {
      if (conversationId === this.props.conversation.ConversationId)
      {
        this.setState({ isRedFlag });
      }
    });
    if ((this.props.storageData as any) && (this.props.storageData as any).enableChat === true)
    {
      const reqNewChat = {
        Participant1:
          this.props.storageData && (this.props.storageData as any).personid
            ? (this.props.storageData as any).personid
            : 0,
        Participant2: this.props.conversation.PersonId || 0,
        ChatID: 0,
      };

      if (
        reqNewChat.Participant1 > 0 &&
        reqNewChat.Participant2 > 0 &&
        reqNewChat.Participant1 !== reqNewChat.Participant2
      )
      {
        this.setState({ canOpenChat: true, reqNewChat: reqNewChat });
      }
    }
    if ((this.props as any).chatData && (this.props as any).chatData.enableChat === true)
    {
      const reqNewChat = {
        Participant1:
          (this.props as any).chatData && (this.props as any).chatData.personid
            ? (this.props as any).chatData.personid
            : 0,
        Participant2: this.props.conversation.PersonId || 0,
        ChatID: 0,
      };
      if (
        reqNewChat.Participant1 > 0 &&
        reqNewChat.Participant2 > 0 &&
        parseInt(reqNewChat.Participant1.toString()) !==
          parseInt(reqNewChat.Participant2.toString())
      )
      {
        this.setState({ canOpenChat: true, reqNewChat: reqNewChat });
      }
    }
  }

  componentWillUnmount()
  {
    if (this.spanTitle && this._titleClickHandler)
    {
      this.spanTitle.removeEventListener('click', this._titleClickHandler);
      this._titleClickHandler = null;
    }
    if (this._unsubRedflag)
    {
      this._unsubRedflag();
      this._unsubRedflag = null;
    }
  }

  componentDidUpdate(prevProps: ConversationItemProps)
  {
    if (this.props.conversation)
    {
      if (this.props.conversation.Finished !== prevProps.conversation.Finished)
      {
        this.setState({ finished: this.props.conversation.Finished || false });
      }
      if (
        this.props.conversation.IsImportant !== prevProps.conversation.IsImportant &&
        this.props.conversation.IsImportant !== this.state.isImportant
      )
      {
        this.setState({ isImportant: this.props.conversation.IsImportant || false });
      }
      if (
        this.props.conversation.IsRedFlag !== prevProps.conversation.IsRedFlag &&
        this.props.conversation.IsRedFlag !== this.state.isRedFlag
      )
      {
        this.setState({ isRedFlag: this.props.conversation.IsRedFlag || false });
      }
      if (
        this.props.conversation.IsFavorite !== prevProps.conversation.IsFavorite &&
        this.props.conversation.IsFavorite !== this.state.isFavorite
      )
      {
        this.setState({ isFavorite: this.props.conversation.IsFavorite || false });
      }
      if (
        prevProps.conversation.Title !== this.props.conversation.Title &&
        this.props.conversation.Title !== this.state.title
      )
      {
        this.setState({
          title: this.props.conversation.Title || '',
          titleOriginal: this.props.conversation.Title || '',
        });
      }
      if (prevProps.conversation.UpdatedBy !== this.state.updatedBy)
      {
        this.setState({
          updatedBy: this.props.conversation.UpdatedBy || '',
          updatedAt: this.props.conversation.UpdatedAt || '',
        });
      }

      if (
        this.props.conversation.ConversationLayers !==
        prevProps.conversation.ConversationLayers
      )
      {
        let layers = [...(this.props.conversation.ConversationLayers || [])];
        layers = layers.sort((a, b) => (a.PriorityInConfigValue || 0) - (b.PriorityInConfigValue || 0));
        layers = layers.filter(x => x.LayerId !== 0);
        const firstLayerColor = (layers[0] as any)?.LayerColor
          ? (layers[0] as any).LayerColor
          : (layers[0] as any)?.Color;

        this.setState({
          conversationLayers: layers,
          firstLayerColor: firstLayerColor ?? this.state.firstLayerColor,
        });
      }
    }

    if (this.props.forceShowDetails !== prevProps.forceShowDetails)
    {
      this.setState({ showDetails: this.props.forceShowDetails === true, tabIndex: 0 });
    }
  }

  onChangedLayersLocal(params: any, isFromInfoWindow?: boolean): void
  {
    const raw: ConversationLayer[] = params?.ConversationLayers || [];
    const layers = raw
      .filter(x => x.LayerId !== 0)
      .sort((a, b) => (a.PriorityInConfigValue || 0) - (b.PriorityInConfigValue || 0));

    const firstLayerColor = (layers[0] as any)?.LayerColor
      ? (layers[0] as any).LayerColor
      : (layers[0] as any)?.Color ?? this.state.firstLayerColor;

    this.setState({ conversationLayers: layers, firstLayerColor });

    if (this.props.onChangedLayers)
    {
      this.props.onChangedLayers(params, isFromInfoWindow);
    }
  }

  onOpenEditHistory(customField: any, onSaveModal: any): void
  {
    this.setState({
      edithistory: { open: true, title: customField.Name, customField, onSaveModal },
    });
  }

  onCloseEditHistory(): void
  {
    this.setState({
      edithistory: { open: false, title: '', customField: null, onSaveModal: null },
    });
  }

  render()
  {
    const { conversation, api } = this.props;
    const {
      finished,
      isRedFlag,
      isFavorite,
      isImportant,
      title,
      icon,
      enableEditTitle,
      openProfilePictureDialog,
      positionProfilePictureX,
      positionProfilePictureY,
      firstLayerColor,
      isGroupDefault,
      showDetails,
      tabIndex,
      edithistory,
    } = this.state;

    let layoutClass = '';
    if (conversation.ConfigValueId === 15)
    {
      layoutClass = 'card-with-image';
    }
    else
    {
      layoutClass = 'card-without-image';
    }

    layoutClass =
      conversation.ConfigValueId !== 15
        ? layoutClass + ' card-has-checkbox'
        : layoutClass + ' card-without-checkbox';

    const iconCssClass =
      icon !== ''
        ? 'identifier-icon-key ' + icon + ' enable-help-tooltip'
        : 'identifier-icon-key icon-infinite-icon enable-help-tooltip';

    const iconCardItemName =
      this.props.conversation.SideMenuText && this.props.conversation.SideMenuText.length > 0
        ? this.props.conversation.SideMenuText + ' Card'
        : '';

    const cssClass = {
      RedFlag: 'corgee-icon-red-flag enable-help-tooltip',
      TaskTitle: `corgee_com_title-card-header-content-task-title-name ${conversation.ConversationId} enable-help-tooltip`,
      Important: 'corgee-icon-important enable-help-tooltip',
    };

    const canRenameTitle = CorgeeHelper.convHasTitleEditPermissions(conversation);
    const tooltipText = {
      CheckBox: 'Mark as Completed',
      RedFlag: 'Mark as Redflag',
      Important: 'Mark as Important',
      TaskTitle: canRenameTitle
        ? 'Title of the card. Click to open Info Window. Double click to rename.'
        : 'Title of the card. Click to open Info Window.',
    };

    if (finished)
    {
      tooltipText.CheckBox = 'Unmark as Completed';
    }
    if (isRedFlag)
    {
      tooltipText.RedFlag = 'Unmark as Redflag';
      cssClass.RedFlag += ' red';
      cssClass.TaskTitle += ' red';
    }
    if (isImportant)
    {
      tooltipText.RedFlag = 'Unmark as Important';
      cssClass.RedFlag += '';
      cssClass.TaskTitle += '';
    }
    if (!conversation.IsEnable)
    {
      tooltipText.CheckBox = 'Deleted items cannot change their complete status';
      tooltipText.RedFlag = 'Deleted items cannot change their red flag status';
      tooltipText.TaskTitle = 'Title of the card. Click to open Info Window.';
    }

    let enableEditTitleValidated = enableEditTitle;

    if (enableEditTitleValidated === true && !canRenameTitle)
    {
      enableEditTitleValidated = false;
    }

    const isDark = document.documentElement.classList.contains('dark');
    const backgroundColor = isDark ? '#3d3a2a' : '#ffffe1';
    const originalBackgroundColor = isDark ? '#333535' : '#ffffff';

    const projectDetailsMatch =
      window.location.hash.match(/\/ProjectDetails\/(\d+)/i) ||
      window.location.href.match(/\/ProjectDetails\/(\d+)/i);
    const isInsideItsProject =
      projectDetailsMatch && projectDetailsMatch[1] === String(conversation.ProjectId);
    const shouldShowProjectName =
      !this.props.hideProjectName &&
      !isInsideItsProject &&
      conversation.ProjectId &&
      conversation.ConfigValueId;

    // Narrow columns give the space back to the title instead of the project name
    const projectNameMinColumnWidth = conversation.ConfigValueId === 9 ? 368 : 420;
    const columnFitsProjectName =
      !this.props.columnWidth || this.props.columnWidth >= projectNameMinColumnWidth;
    // Disabled or not-accessible projects are shown but not navigable
    const isProjectEnabled = conversation.ProjectIsEnable !== false;

    const showProjectNameInHeader = Boolean(
      shouldShowProjectName &&
        (conversation.IsEnable === false || columnFitsProjectName),
    );

    return (
      <div
        ref={() => {}}
        className={
          ((conversation as any).Highlight
            ? 'corgee_com_title-card notification-highlight'
            : 'corgee_com_title-card') +
          (conversation.IsEnable === false ? ' recycle-bin-item' : '')
        }
        style={{
          backgroundColor: (conversation as any).Highlight
            ? backgroundColor
            : originalBackgroundColor,
          position: 'relative',
        }}
      >
        <div className="corgee_com_title-card-header" style={{ position: 'relative' }}>
          {isImportant === true && <div className="triangule-important "></div>}
          <div
            className={
              'corgee_com_title-card-header-status-bar' +
              (enableEditTitleValidated ? ' is-renaming' : '')
            }
          >
            {/*Card Header Left Section*/}
            <div className={'corgee_com_title-card-status-bar-layout-type ' + layoutClass}>
              {/*Layers Section*/}
              <div
                className="corgee_com_title-card-header-layers enable-help-tooltip layers-help-tooltip"
                data-title="Layers"
              >
                {this.state.conversationLayers.map(layer => (
                  <span
                    key={'cl-' + layer.ConversationId + '-' + layer.LayerId}
                    className="corgee_com_title-card-layer "
                    style={{
                      backgroundColor: (layer as any).LayerColor
                        ? (layer as any).LayerColor
                        : (layer as any).Color,
                    }}
                  ></span>
                ))}
              </div>

              {/*Icons Section*/}
              <div className="corgee_com_title-card-header-icons ">
                <span className={iconCssClass} data-title={iconCardItemName}></span>
                {conversation.ConfigValueId === 15 && (
                  <span
                    className="user-picture-image-conversation infoWindow-picture"
                    style={{ backgroundImage: 'url(' + conversation.ImageName + ')' }}
                    onMouseEnter={this.onHoverProfilePicture}
                    onMouseLeave={this.onLeaveMiniaturePicture}
                  ></span>
                )}
                {/*Checkbox Section — hidden for parent cards (IsParent); progress pill shown instead*/}
                {conversation.ConfigValueId !== 1 &&
                  conversation.ConfigValueId !== 9 &&
                  conversation.ConfigValueId !== 15 &&
                  !conversation.IsParent && (
                  <span className="corgee_com_checkbox ">
                    {conversation.IsEnable ? (
                      <input
                        id={'task_Card_Checkbox' + conversation.ConversationId}
                        className="taskCardCheckbox"
                        type="checkbox"
                        checked={finished}
                        onChange={this.onChangeFinished}
                      />
                    ) : (
                      <input
                        id={'task_Card_Checkbox' + conversation.ConversationId}
                        className="taskCardCheckbox"
                        type="checkbox"
                        checked={finished}
                        disabled
                      />
                    )}
                    <label
                      htmlFor={'task_Card_Checkbox' + conversation.ConversationId}
                      className="conversationCheckbox enable-help-tooltip"
                      data-title={tooltipText.CheckBox}
                    ></label>
                  </span>
                )}
                {/*Progress pill — replaces checkbox on parent cards*/}
                {conversation.IsParent === true &&
                  conversation.ConfigValueId !== 1 &&
                  conversation.ConfigValueId !== 9 &&
                  conversation.ConfigValueId !== 15 && (
                  <span
                    className="corgee_com_card-progress-pill enable-help-tooltip"
                    data-title={`Progress: ${Math.round(conversation.Progress || 0)}%`}
                  >
                    <span
                      className="corgee_com_card-progress-pill-fill"
                      style={{
                        width: `${Math.min(100, Math.max(0, conversation.Progress || 0))}%`,
                      }}
                    />
                  </span>
                )}
              </div>
            </div>

            {React.createElement(ProfilePictureModal as any, {
              ...this.props,
              ref: (el: any) =>
              {
                this.profilePictureItem = el;
              },
              closeProfilePictureModal: this.closeProfilePictureModal,
              openProfilePictureDialog: openProfilePictureDialog,
              api: api,
              conversation: conversation,
              positionX: positionProfilePictureX,
              positionY: positionProfilePictureY,
            })}

            {/*Card Header Center Section*/}
            <div className="corgee_com_title-card-header-center-content cancel-drag">
              <div className="corgee_com_title-card-header-content-task-title ">
                <div className="corgee_com_title-card-header-content-task-editable">
                  {enableEditTitleValidated === false && (
                    <span
                      ref={el =>
                      {
                        this.spanTitle = el;
                      }}
                      className={cssClass.TaskTitle}
                      data-title={tooltipText.TaskTitle}
                    >
                      {title}
                    </span>
                  )}
                  {enableEditTitleValidated === true && (
                    <input
                      className="corgee_com_input "
                      type="text"
                      ref={el =>
                      {
                        this.inputTitle = el;
                      }}
                      autoFocus
                      defaultValue={title}
                      onKeyUp={this.onEditTitle}
                      onFocus={e =>
                      {
                        const len = e.target.value.length;
                        e.target.setSelectionRange(len, len);
                        e.target.scrollLeft = e.target.scrollWidth;
                      }}
                    />
                  )}
                  {enableEditTitleValidated === true && (
                    <button
                      type="button"
                      style={{
                        display: 'inline-block',
                        backgroundColor: firstLayerColor,
                        borderColor: firstLayerColor,
                      }}
                      onClick={this.onSaveTitle}
                      className="corgee_com_button corgee_com_sm-button btnChangeColorWithLayer"
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/*Card Header Right Section*/}
            <div
              className={
                showProjectNameInHeader && conversation.IsProjectConversation && conversation.Title
                  ? 'corgee_com_title-card-header-status-bar-tools area-with-project-name'
                  : showProjectNameInHeader
                    ? 'corgee_com_title-card-header-status-bar-tools'
                    : 'corgee_com_title-card-header-status-bar-tools area-without-project-name'
              }
            >
              {(conversation.IsEnable !== false || showProjectNameInHeader) && (
                <div className={`corgee_com_title-card-header-visible-icons${conversation.ConfigValueId === 9 ? ' folder-icon-item' : ''}`}>
                  {showProjectNameInHeader && (
                    <a
                      className={
                        'corgee_com_title-card-header-project-name go-to-project enable-help-tooltip' +
                        (isProjectEnabled ? '' : ' no-click-project')
                      }
                      data-title={
                        isProjectEnabled
                          ? 'Click to go to project view'
                          : 'This project is not available'
                      }
                      onClick={isProjectEnabled ? this.onGoToProjectView : undefined}
                    >
                      {conversation.ConfigValueId !== 9 ? (
                        conversation.ProjectName ? (
                          conversation.ProjectName
                        ) : (
                          title
                        )
                      ) : (
                        <i className="fa fa-folder-open-o"></i>
                      )}
                    </a>
                  )}
                  {conversation.IsEnable !== false && !this.props.isHomeView && (
                    <div className="corgee_com_title-card-header-actions ">
                      {!this.props.isHomeView && !enableEditTitleValidated && (
                        <div
                          className={
                            'title-card-action-icon bookmark ' + (isFavorite ? 'favorite' : '')
                          }
                          onClick={this.onSendToBookmarks}
                        >
                          <i
                            className="material-icons"
                            data-conversationid={conversation.ConversationId}
                          >
                            {isFavorite ? 'bookmark' : 'bookmark_border'}
                          </i>
                        </div>
                      )}
                      {!this.props.isHomeView && !enableEditTitleValidated && (
                        <div className="title-card-action-icon red-flag-card">
                          <i
                            className="btn-show-details-widget enable-help-tooltip"
                            data-title="Show details"
                            data-conversationid={conversation.ConversationId}
                            onClick={this.onOpenInfoWindow}
                          ></i>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {!this.props.hideActionMenu && (
                <div className="corgee_com_title-card-header-menu">
                  {React.createElement(ActionMenuConversation as any, {
                    ...this.props,
                    isRedFlag: isRedFlag,
                    isImportant: isImportant,
                    onMarkAsRedFlag: this.onMarkAsRedFlag,
                    onMarkAsImportant: this.onMarkAsImportant,
                    onConverToProccess: this.onConverToProccess,
                    isGroupDefault: isGroupDefault,
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        {showDetails &&
          (() =>
          {
            const hasPhases =
              conversation.HasPhases === true &&
              Array.isArray(conversation.Phases) &&
              conversation.Phases.length > 0;
            const activePhase =
              hasPhases && tabIndex > 0
                ? conversation.Phases![tabIndex - 1]
                : {
                  ConversationPhaseId: 0,
                  CoreTaskId: conversation.CoreTaskId ?? (conversation as any).CoreTaskID,
                };

            return (
              <div className="corgee_com_title-card-details-panel">
                {hasPhases && (
                  <div className="corgee_com_title-card-details-tabs">
                    <Tabs
                      selectedIndex={tabIndex}
                      onSelect={idx =>
                      {
                        this.setState({ tabIndex: idx });
                        this.props.onTabChange?.(idx);
                      }}
                    >
                      <TabList>
                        <Tab className="react-tabs__tab">All Phases</Tab>
                        {conversation.Phases!.map((phase, idx) => (
                          <Tab className="react-tabs__tab" key={phase.ConversationPhaseId ?? idx}>
                            {phase.Title ?? phase.Name ?? `Phase ${idx + 1}`}
                          </Tab>
                        ))}
                      </TabList>
                      <TabPanel />
                      {conversation.Phases!.map((_p, idx) => (
                        <TabPanel key={`panel-${idx}`} />
                      ))}
                    </Tabs>
                  </div>
                )}
                <CustomFields
                  config={{
                    apiUrl: api.url,
                    authToken: api.token,
                    showHeader: true,
                    disableAutoSave: false,
                    isNew: false,
                    canEdit: CorgeeHelper.convHasEditPermissions(conversation),
                    onChangeLayers: this.onChangedLayersLocal,
                    addLayerToCard: this.props.onAddLayerToCard as any,
                    addLayerToProject: this.props.onAddLayerToProject as any,
                  }}
                  item={conversation as any}
                  projectId={conversation.ProjectId ?? null}
                  configValueId={conversation.ConfigValueId ?? null}
                  phaseSelected={activePhase as any}
                  onOpenEditHistory={this.onOpenEditHistory as any}
                />
              </div>
            );
          })()}

        {edithistory.open && (
          <EditDetailHistory
            customField={edithistory.customField}
            open={edithistory.open}
            api={api}
            title={edithistory.title}
            onClose={this.onCloseEditHistory}
            onSaveModal={edithistory.onSaveModal}
          />
        )}
        {this.state.modalEditMultipleCard.open &&
        createPortal(
          <EditMultipleCards
            config={this.state.modalEditMultipleCard.config}
            isOpen={this.state.modalEditMultipleCard.open}
            onIsOpen={() => this.setState({ modalEditMultipleCard: { open: false, config: null } })}
          />,
          document.body,
        )}
      </div>
    );
  }
}

function ConversationViewTitleWrapper(props: Omit<ConversationItemProps, 'navigate'>)
{
  const navigate = useNavigate();
  return <ConversationViewTitle {...props} navigate={navigate} />;
}

export default ConversationViewTitleWrapper;
